import React, { useEffect, useState } from "react";
import { observer } from "mobx-react";

import { useRootAppStore } from "@hooks";
import {
	ChatHeader,
	ChatMinimizeButton,
	ChatCloseButton,
	ChatContent,
	ChatNameUpdate,
} from "@features/chat/mobile";
import OfferIcon from "@components/icons/Offer";
import { ChatEntryPoint } from "@data-types/chat";
import { useTranslation } from "react-i18next";

const ChatBox = observer(() => {
	const { chatViewStore } = useRootAppStore();
	const { t } = useTranslation();

	if (!chatViewStore.chatDisplayName) {
		return (
			<div className="chat__card">
				<ChatNameUpdate />
			</div>
		);
	}

	return (
		<div className="chat__card">
			<ChatHeader />
			<ChatContent />
		</div>
	);
});

export default ChatBox;
